import { BaseEntity } from '../../../../models';

export class UsuarioEmailAdministrativo implements BaseEntity {
    readonly id: number;
    idUsuario: number;
    email: string;
}
